function renderStackedTable() {
    const table = document.querySelector('tbody')
    if (!table) return
  
    // Check if already stacked to avoid duplication
    if (document.querySelector('.stacked-table-container')) return
  
    const firstRow = table.querySelector('tr')
    const headerCells = firstRow.querySelectorAll('td')
    const headers = Array.from(headerCells).map(cell => cell.innerText.trim())
  
    const rows = Array.from(table.querySelectorAll('tr')).slice(1)
  
    const stackedContainer = document.createElement('div')
    stackedContainer.classList.add('stacked-table-container')
  
    rows.forEach(row => {
      const cells = row.querySelectorAll('td')
      const card = document.createElement('div')
      card.classList.add('stacked-card')
  
      cells.forEach((cell, index) => {
        const label = document.createElement('div')
        label.classList.add('stacked-label')
        label.innerText = headers[index]
  
        const value = document.createElement('div')
        value.classList.add('stacked-value')
        value.innerHTML = cell.innerHTML
  
        const item = document.createElement('div')
        item.classList.add('stacked-item')
        item.appendChild(label)
        item.appendChild(value)
  
        card.appendChild(item)
      })
  
      stackedContainer.appendChild(card)
    })
  
    table.parentNode.replaceChild(stackedContainer, table)
  }
  
  function removeStackedTable() {
    const stackedContainer = document.querySelector('.stacked-table-container')
    if (!stackedContainer) return
  
    // Restore original table (assumes table backup exists in a hidden clone)
    const originalTable = document.querySelector('tbody[data-original]')
    if (originalTable) {
      stackedContainer.parentNode.replaceChild(originalTable, stackedContainer)
    }
  }
  
  // Backup original table once
  const table = document.querySelector('tbody')
  if (table) {
    const clone = table.cloneNode(true)
    clone.setAttribute('data-original', 'true')
    clone.style.display = 'none'
    table.parentNode.appendChild(clone)
  }
  
  // Run on load and resize
  function handleResize() {
    if (window.innerWidth < 1024) {
      renderStackedTable()
    } else {
      removeStackedTable()
    }
  }
  
  window.addEventListener('load', handleResize)
  window.addEventListener('resize', handleResize)
  